import moment from 'moment';
import { all, fork, put, takeLatest } from 'redux-saga/effects';
import { switchLanguageSuccess } from '../actions/Setting';
import { SWITCH_LANGUAGE } from '../constants/ActionTypes';
import { LOCALES, LOCALE } from '../constants/Values';
import { addCookie } from '../util/cookies';

function* switchLanguage({ payload }) {
  const appLocale = LOCALES.find(locale => locale.locale === payload.locale);
  addCookie(LOCALE, payload.locale, true);

  yield put(switchLanguageSuccess(appLocale));
  moment.locale(payload.locale);
}

export function* switchLanguageSaga() {
  yield takeLatest(SWITCH_LANGUAGE, switchLanguage);
}

export default function* rootSaga() {
  yield all([fork(switchLanguageSaga)]);
}
